import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Achat } from '../../models/achat';
import { RestService } from "../rest.service";
import { Configuration } from '../../app.constants';

@Injectable()
export class AchatService extends RestService {
    constructor(_http: HttpClient, _configuration: Configuration) {
        super(_http,_configuration);
        this.modelName = 'achat';
        this.modelClass = Achat;
    }

    public getByFactureId(id: number): Observable<Achat[]>{
      return super.search("facture_id",id,"eq").pipe(
        map((tab)=> {
          return <Achat[]>tab.map(unit => new Achat(unit) );
        }))
      ;
    }

}
